import { mapActions } from "vuex";

export default {
  methods: {
    catch_error(err){
      if (err.response){
        if (err.response.status == 403){
          this.addNotification({type: 'error', msg: 'Sem permissão para essa ação.'})
        } else if (err.response.status == 401){
          this.addNotification({type: 'error', msg: 'Você não está autorizado.'})
          this.$router.push('/login')
        }
      }
    },
  },
  ...mapActions({
    // function: 'Module/action'
    addNotification: 'Notification/add'
  })
}